import type React from "react";
import { useGoals } from "@/hooks/useGoals";
import { useProgress } from "@/hooks/useProgress";
import { useMemo } from "react";

const GoalSummary: React.FC = () => {
	const { goals, loading: goalsLoading, error: goalsError } = useGoals();
	const {
		progress,
		loading: progressLoading,
		error: progressError,
	} = useProgress();

	// 各目標の最新の進捗率を計算
	const goalsWithProgress = useMemo(() => {
		if (!goals || !progress) return [];

		return goals.map((goal) => {
			const latestProgress = progress
				.filter((p) => p.goalId === goal.id)
				.sort(
					(a, b) =>
						new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime(),
				)[0];

			return {
				...goal,
				progressRate: latestProgress?.progress ?? 0,
			};
		});
	}, [goals, progress]);

	if (goalsLoading || progressLoading) return <p>読み込み中...</p>;
	if (goalsError) return <p>エラーが発生しました: {goalsError.message}</p>;
	if (progressError)
		return <p>エラーが発生しました: {progressError.message}</p>;

	return (
		<ul className="space-y-2">
			{goalsWithProgress.slice(0, 3).map((goal) => (
				<li key={goal.id} className="flex justify-between items-center">
					<div className="flex-1">
						<span className="font-medium">{goal.title}</span>
						<span className="ml-2 text-sm text-gray-500">
							{goal.status === "completed"
								? "完了"
								: goal.status === "in_progress"
									? "進行中"
									: "未着手"}
						</span>
					</div>
					<span className="text-sm text-gray-500">{goal.progressRate}%</span>
				</li>
			))}
		</ul>
	);
};

export default GoalSummary;
